import { createAction } from '../helpers/createAction'

export const requestLocalStorageGet = createAction<{
  id: string
  key: string
}>('requestLocalStorageGet')

export const requestLocalStorageSet = createAction<{
  id: string
  key: string
  value: string
}>('requestLocalStorageSet')

export const requestLocalStorageRemove = createAction<{
  id: string
  key: string
}>('requestLocalStorageRemove')

export const requestLocalStorageClear = createAction<{
  id: string
  prefix?: string
}>('requestLocalStorageClear')

export const requestLocalStorageKeys = createAction<{
  id: string
}>('requestLocalStorageKeys')

export const requestLocalStorageHas = createAction<{
  id: string
  key: string
}>('requestLocalStorageHas')

export const sendLocalStorageResponse = createAction<{
  id: string
  value: string | string[] | boolean | null
  success: boolean
  error?: string
}>('sendLocalStorageResponse')

export const sendLocalStorageChanged = createAction<{
  key?: string
  value?: string | null
  operation: 'set' | 'remove' | 'clear'
  source?: 'host' | 'remote'
}>('sendLocalStorageChanged')
